// src/components/Header.jsx
import React, { useState } from 'react';
import { Link } from 'react-router-dom';

const Header = () => {
  const [isNavActive, setIsNavActive] = useState(false);

  const toggleNav = () => setIsNavActive(!isNavActive);
  const handleLinkClick = () => setIsNavActive(false);

  return (
    <header className="fixed top-0 left-0 w-full z-50 bg-white md:dark:bg-gray-900 shadow-md">
      <div className="max-w-7xl mx-auto px-4 py-3 flex items-center justify-between">
        {/* Logo */}
        <Link to="/" className="flex items-center gap-2" onClick={handleLinkClick}>
          <img src="/Assets/logo1.png" alt="Logo" className="h-12 md:h-14 w-auto" />
          <span className="text-base md:text-lg font-bold text-[#111827] md:dark:text-white">
            AG EDU HUB Foundation
          </span>
        </Link>

        {/* Mobile Toggle Button */}
        <div className="md:hidden">
          <button
            className="text-3xl text-[#111827] md:dark:text-white focus:outline-none"
            onClick={toggleNav}
            aria-label="Toggle Navigation"
          >
            ☰
          </button>
        </div>

        {/* Desktop Navigation */}
        <nav className="hidden md:flex items-center gap-5 whitespace-nowrap text-gray-700 dark:text-gray-200 font-medium">
          <Link to="/" onClick={handleLinkClick}>Home</Link>
          <Link to="/ag-eduhub-foundation" onClick={handleLinkClick}>Foundation</Link>
          <Link to="/insights" onClick={handleLinkClick}>Insights</Link>
          <Link to="/about" onClick={handleLinkClick}>About</Link>
           <Link to="/resource-team" onClick={handleLinkClick}>Resource Team</Link>
          
          <Link to="/careers" onClick={handleLinkClick}>Careers</Link>
          <Link to="/mou" onClick={handleLinkClick}>MOU</Link>
          <Link to="/gallery" onClick={handleLinkClick}>Gallery</Link>

           <Link to="/trainings-and-development" onClick={handleLinkClick}> Trainings</Link> 
           <Link to="/donations" onClick={handleLinkClick}>Donations</Link>
           
          <Link to="/contact" onClick={handleLinkClick}>Contact</Link>
         
        </nav>
      </div>

      {/* Mobile Navigation */}
      {isNavActive && (
        <div className="md:hidden px-4 pb-4 bg-white dark:bg-gray-900 text-gray-800 dark:text-white">
          <nav className="flex flex-col gap-3">
            <Link to="/" onClick={handleLinkClick}>Home</Link>
            <Link to="/ag-eduhub-foundation" onClick={handleLinkClick}>Foundation</Link>
            <Link to="/insights" onClick={handleLinkClick}>Insights</Link>
            <Link to="/about" onClick={handleLinkClick}>About</Link>
            <Link to="/resource-team" onClick={handleLinkClick}>Resource Team</Link>
            
            <Link to="/careers" onClick={handleLinkClick}>Careers</Link>
            <Link to="/mou" onClick={handleLinkClick}>MOU</Link>
            <Link to="/gallery" onClick={handleLinkClick}>Gallery</Link>

             <Link to="/trainings-and-development" onClick={handleLinkClick}> Trainings</Link> 
              <Link to="/donations" onClick={handleLinkClick}>Donations</Link>
            <Link to="/contact" onClick={handleLinkClick}>Contact</Link>
            
          </nav>
        </div>
      )}
    </header>
  );
};

export default Header;
